/**
 * @generated SignedSource<<32033062555972cb9bfca9159f474bec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdateReferralPartnerSourceModal_referralPartnerSource$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"ReferralPartnerSourceForm_referralPartnerSource">;
  readonly " $fragmentType": "UpdateReferralPartnerSourceModal_referralPartnerSource";
};
export type UpdateReferralPartnerSourceModal_referralPartnerSource$key = {
  readonly " $data"?: UpdateReferralPartnerSourceModal_referralPartnerSource$data;
  readonly " $fragmentSpreads": FragmentRefs<"UpdateReferralPartnerSourceModal_referralPartnerSource">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UpdateReferralPartnerSourceModal_referralPartnerSource",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ReferralPartnerSourceForm_referralPartnerSource"
    }
  ],
  "type": "ReferralPartnerSource",
  "abstractKey": null
};

(node as any).hash = "2af33fe2a4c51cfd14405a5110aa6242";

export default node;
